<template>
  <div
      class="input d-flex align-items-center position-relative"
      :class="{
          'item-danger': warning || searchLocationError,
          'active': isActive && !warning
      }"
  >
    <SearchIcon
        class="input-search-icon cursor-pointer position-absolute"
        v-if="shouldHaveSearch && showSearch"
    />
    <input
        :value="modelValue"
        type="text"
        class="text-black"
        :placeholder="placeholder"
        @focus="handleInputFocus"
        @blur="handleInputBlur"
        @input="handleInput"
        @keydown.enter="onInputEnterClick"
        :style="[shouldHaveSearchClear && showClear && {minWidth: '280px'} ]"
        :name="name"
        :id="id"
        v-if="!autocomplete"
    >
    <GMapAutocomplete
        v-if="autocomplete"
        :placeholder="placeholder"
        @place_changed="handleLocation"
        @input="handleInput"
        @focus="handleInputFocus"
        @blur="handleInputBlur"
        @keydown.enter="onInputEnterClick"
        class="input autocomplete-input"
        :class="{'hasIcons': showSearch}"
        :options="autocompleteOptions"
        :value="modelValue"
    >
    </GMapAutocomplete>
    <span class="position-absolute search-location-error" v-if="searchLocationError">
      The location could not be found
    </span>
    <SearchClear
        v-if="shouldHaveSearchClear && showClear"
        class="me-2 position-absolute clear-icon"
        role="button"
        @click="clearInput"
    />
  </div>
  <ButtonBlue
      v-if="shouldHaveSearchButton"
      text="Search"
      class="ms-4"
      @click="onSearchClick"
  />
</template>

<script>
import SearchIcon from '@/assets/icons/search-icon';
import SearchClear from '@/assets/icons/search-clear-icon';
import {handleListeners, parseLocation} from "@/utils/utils";
import {autocompleteOptions} from "@/config/config";
import ButtonBlue from './ButtonBlue.vue';

export default {
  name: 'Input',
  data() {
    return {
      isActive: false,
      showClear: false,
      showSearch: false,
      isDesktop: false,
      searchLocationError: false
    }
  },
  components: { SearchIcon, SearchClear, ButtonBlue },
  props: {
    placeholder: String,
    warning: Boolean,
    shouldHaveSearch: Boolean,
    shouldHaveSearchClear: Boolean,
    shouldHaveSearchButton: Boolean,
    modelValue: [String, Number],
    name: String,
    id: String,
    autocomplete: Boolean,
    autocompleteOptions: {
      componentRestrictions: {'country': String},
      types: Array
    },
    phone: Boolean
  },
  methods: {
    handleInputFocus(e) {
      this.isActive = true
      if (e.target.value.length && this.isDesktop) {
        this.showClear = true
      }
    },
    handleInputBlur() {
      this.isActive = false
    },
    handleInput(e) {
      this.$emit('update:modelValue', e.target.value)
      if(e.target.value.length > 0 && this.isDesktop) {
        this.showClear = true
        this.showSearch = true
      } else {
        this.searchLocationError = false
        this.showClear = false
        this.showSearch = false
        this.$emit('onClear')
      }

    },
    clearInput(){
      this.$emit('update:modelValue', '')
      this.$emit('onClear')
      this.showClear = false
      this.showSearch = false
    },
    handleLocation(place) {
      parseLocation(place, (locationInfo) => {
        this.searchLocationError = false;
        this.$emit('placeChanged', locationInfo)
      })
    },
    onSearchClick() {
      const autocompleteService = new google.maps.places.AutocompleteService();

      autocompleteService.getPlacePredictions({ input: this.$props.modelValue, ...autocompleteOptions }, (predictions) => {
        if (predictions) {
          parseLocation(predictions[0], (locationInfo) => {
            this.searchLocationError = false;
            this.$emit('placeChanged', locationInfo)
            this.$emit('update:modelValue', locationInfo.formatted_address)
          })
        } else {
            this.searchLocationError = true;
          }
      })
    },
    onInputEnterClick() {
      this.$emit('onInputEnterClick');

      if (this.$props.autocomplete) {
        this.onSearchClick();
      }
    },
    handleScreenWidth(){
      this.isDesktop= window.matchMedia('(min-width: 992px)').matches
    },
  },
  mounted() {
    this.handleScreenWidth()
    handleListeners(['resize'], this.handleScreenWidth)
  },
  unMounted() {
    handleListeners(['resize',], this.handleScreenWidth, true)
  }
}
</script>
